import { render, staticRenderFns } from "./SendSmsMessageV2.vue?vue&type=template&id=482ae95d&scoped=true"
import script from "./SendSmsMessageV2.vue?vue&type=script&lang=js"
export * from "./SendSmsMessageV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482ae95d",
  null
  
)

export default component.exports